import React, { Component } from "react"
import PropTypes from "prop-types"

export default class FiltersBar extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedYear: this.props.values.min_year || "",
      selectedBrand: this.props.values.brand || "",
      selectedModel: this.props.values.model || "",
    }
  }

  _populateYearsList = () => {
    const minYear = parseInt(this.props.searchCriteria.minYear)
    const maxYear = parseInt(this.props.searchCriteria.maxYear)

    const fillRange = (start, end) => {
      return Array(end - start + 1)
        .fill()
        .map((item, index) => start + index)
    }
    const allYears = fillRange(minYear, maxYear).reverse()

    return [
      <option key="empty" value="">
        {this.props.strings.selectMinYearLabel}
      </option>,
      ...allYears.map((year) => (
        <option key={year} value={year}>
          {year}
        </option>
      )),
    ]
  }

  _populateBrandsList = () => {
    let _brandsList = [
      <option key="empty" value="">
        {this.props.strings.selectBrandLabel}
      </option>,
    ]
    _brandsList = _brandsList.concat(
      this.props.searchCriteria.brands.map((brand) => (
        <option key={brand} value={brand}>
          {brand}
        </option>
      ))
    )

    return _brandsList
  }

  _populateModelsList = () => {
    let _modelsList = [
      <option key="empty" value="">
        {this.props.strings.selectModelLabel}
      </option>,
    ]

    const modelsByBrand = this.props.searchCriteria.modelsByBrand

    if (this.state.selectedBrand && modelsByBrand[this.state.selectedBrand]) {
      _modelsList = _modelsList.concat(
        modelsByBrand[this.state.selectedBrand].map((model) => (
          <option key={model} value={model}>
            {model}
          </option>
        ))
      )
    }

    return _modelsList
  }

  _handleBrandChange = (e) => {
    this.setState({
      ...this.state,
      selectedBrand: e.target.value,
      selectedModel: "",
    })

    this.props.onFilterChange({ brand: e.target.value, model: "" })
  }

  _handleModelChange = (e) => {
    this.setState({
      ...this.state,
      selectedModel: e.target.value,
    })

    this.props.onFilterChange({ model: e.target.value })
  }

  _handleYearChange = (e) => {
    this.setState({
      ...this.state,
      selectedYear: e.target.value,
    })
    this.props.onFilterChange({ min_year: parseInt(e.target.value) })
  }

  render() {
    return (
      // initially populated from props passed through the flow
      <div className="filters-bar">
        {/* brand selector */}
        <span style={{ display: "inline-block" }}>
          <label className="sr-only" htmlFor="brand">{this.props.strings.selectBrandLabel}</label>
          <select
            id="brand"
            key="filter-brand"
            onChange={(e) => this._handleBrandChange(e)}
            defaultValue={this.state.selectedBrand}
            className={this.state.selectedBrand ? "valid" : ""}
            autoComplete="off"
          >
            {this._populateBrandsList()}
          </select>
        </span>

        {/* model selector */}
        {this.state.selectedBrand ? (
          <span style={{ display: "inline-block" }}>
            <label className="sr-only" htmlFor="model">{this.props.strings.selectModelLabel}</label>
            <select
              id="model"
              key="filter-model"
              onChange={(e) => this._handleModelChange(e)}
              defaultValue={this.state.selectedModel}
              className={this.state.selectedModel ? "valid" : ""}
              autoComplete="off"
            >
              {this._populateModelsList()}
            </select>
          </span>
        ) : null}

        {/* min year selector */}
        {this.state.selectedBrand ? (
          <span style={{ display: "inline-block" }}>
            <label className="sr-only" htmlFor="min-year">{this.props.strings.selectMinYearLabel}</label>
            <select
              id="min-year"
              key="filter-min-year"
              onChange={(e) => this._handleYearChange(e)}
              defaultValue={this.state.selectedYear}
              className={this.state.selectedYear ? "valid" : ""}
              autoComplete="off"
            >
              {this._populateYearsList()}
            </select>
          </span>
        ) : null}
      </div>
    )
  }
}

FiltersBar.propTypes = {
  searchCriteria: PropTypes.object,
  onFilterChange: PropTypes.func,
  values: PropTypes.object,
  strings: PropTypes.object,
}
